/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BacksolveUsageDetails } from './BacksolveUsageDetails';
import type { ConvertibleNoteModel } from './ConvertibleNoteModel';
import type { DividendRateLedgerItemModel } from './DividendRateLedgerItemModel';
import type { FODUsageDetails } from './FODUsageDetails';
import type { LiqPrefLedgerConfig } from './LiqPrefLedgerConfig';
import type { MultipleInvestmentRow } from './MultipleInvestmentRow';
export type SecurityRead = {
  readonly id?: number;
  convertible_notes: Array<ConvertibleNoteModel>;
  liquidation_preference_ledger_config?: LiqPrefLedgerConfig;
  dividend_rate_ledger_items: Array<DividendRateLedgerItemModel>;
  mapping_references?: Array<string | null>;
  citation_references?: Array<string | null>;
  readonly cell_annotations?: Record<string, Record<string, {
    row_mode?: 'single_cell' | 'single_row' | 'multi_row';
    columns_config?: Array<any>;
    rows?: Array<{
      position?: number;
      value?: string | null;
      metadata?: any;
    }>;
  }>>;
  fod_usage_details?: FODUsageDetails;
  backsolve_usage_details?: BacksolveUsageDetails;
  readonly multiple_investments?: Array<MultipleInvestmentRow>;
  readonly created_at?: string;
  readonly updated_at?: string;
  name: string;
  readonly last_audit_event_id?: string | null;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  /**
   * Official legal security name; `name` is its display alias
   */
  legal_name?: string | null;
  /**
   * ID from external system to correlate with (e.g. iLevel security)
   */
  external_id?: string | null;
  investment_date?: string | null;
  issue_price?: string | null;
  shares_outstanding?: string | null;
  conversion_rate?: string | null;
  pik_shares?: string | null;
  shares_diluted?: string | null;
  current_own_percent?: string | null;
  diluted_own_percent?: string | null;
  strike_price?: string | null;
  liquidation_preference?: string | null;
  seniority?: number | null;
  is_participating?: boolean | null;
  is_participation_cap?: boolean | null;
  participation_cap?: string | null;
  has_dividends?: boolean | null;
  has_multiple_investments?: boolean | null;
  dividend_payment_type?: SecurityRead.dividend_payment_type | null;
  dividend_rate?: string | null;
  has_compounding?: boolean | null;
  compounding_period?: number | null;
  accrued_dividends?: string | null;
  initial_liquidation_pref?: string | null;
  total_preference?: string | null;
  order?: number | null;
  options_ledger?: any;
  security_ref?: string | null;
  underlying_security_ref?: string | null;
  security_group_ref?: string | null;
  is_hidden?: boolean | null;
  total_note_preference?: string | null;
  total_note_value_at_md?: string | null;
  cap_table: number;
  security_type?: number | null;
  underlying_security?: number | null;
};
export namespace SecurityRead {
  export enum dividend_payment_type {
    '_0' = 0,
    '_1' = 1,
  }
}

